<template>
  <div>
    <vs-popup class="sales-quote-email-log-popup"
              id="popup"
              :title='`SALES QUOTE EMAIL LOG - ${quote_code}`'
              :active.sync="open"
              :buttons-hidden="true">
      <vx-card no-shadow >

        <div class="vx-row" v-if="is_on_send_mode">
          <div class="vx-col w-full text-warning">
            <b>This quote has already been sent to these customers. Do you wish to resend?</b>
          </div>
        </div>

            <vs-table class="my-8" hoverFlat id="quote_item_table" :data="email_log" stripe>
              <template slot="thead">
                <vs-th>DATE/TIME</vs-th>
                <vs-th>STAFF USER (SENT BY)</vs-th>
                <vs-th>CUSTOMER USER (SENT TO)</vs-th>
                <vs-th>CUSTOMER USER EMAIL</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr :key="indextr"
                       v-for="(tr_item, indextr) in data">

                  <vs-td>
                    {{ __dateTimeFormatter(data[indextr].created_at) }}
                  </vs-td>
                  <vs-td>
                    {{ data[indextr].created_by_staff_name }}
                  </vs-td>
                  <vs-td>
                    {{ data[indextr].customer_user_name }}
                  </vs-td>
                  <vs-td>
                    {{ data[indextr].customer_user_email }}
                  </vs-td>

                </vs-tr>
              </template>
            </vs-table>
        <div v-if="is_on_send_mode" class="flex flex-wrap items-center justify-end mt-8">
          <vs-button @click.stop="onClickResendEmail" class="ml-auto mt-2">Resend</vs-button>
          <vs-button @click="open = false" class="ml-4 mt-2" type="border" color="warning">Close</vs-button>
        </div>

      </vx-card>
    </vs-popup>
  </div>
</template>

<script>
import {RepositoryFactory} from "@/repository/RepositoryFactory";
const CustomerRepository = RepositoryFactory.get('customer')
import ErrorMessages from "@/mixins/ErrorMessages";
import successMessage from "../../../mixins/SuccessMessage";

export default {
  name: "ViewSalesQuotePopUp",
  data() {
    return {
      salesQuote: {},
      email_log: [],
      quote_code: '',
      customer_id: '',
      quote_id: '',
      open: false,
      is_on_send_mode: false,
    }
  },
  mixins: [ ErrorMessages, successMessage],
  methods:{
    async openPopup(email_log, quote_code = '', is_on_send_mode = false, quote_id = '', customer_id = '') {
      this.email_log = email_log
      this.quote_code = quote_code
      this.is_on_send_mode = is_on_send_mode
      this.customer_id = customer_id
      this.quote_id = quote_id
      this.open = true
    },
    async onClickResendEmail() {
      this.open = false
      this.$parent.fetchCustomerListForSend(this.quote_id, this.customer_id)
    }
  }
}
</script>

<style scoped>

.sales-quote-email-log-popup >>> .vs-popup {
  min-width: 50% !important;
}
.label {

}

</style>
